import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svgs/icons/search.svg'


const _withScopeId = n => (_pushScopeId("data-v-55253631"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "status",
  src: _imports_0,
  alt: "search"
}, null, -1))
const _hoisted_3 = ["disable"]
const _hoisted_4 = {
  class: "hidden",
  style: { width: '100%' }
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Not Found", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "container-result-dropdown",
    style: _normalizeStyle({ width: _ctx.width })
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.msg), 1),
    _hoisted_1,
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "toggle",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      style: _normalizeStyle(_ctx.styles()),
      disable: _ctx.isNoCampaign,
      placeholder: "Please selected name campaign",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checked(_ctx.value)))
    }, null, 44, _hoisted_3), [
      [_vModelText, _ctx.value]
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_ctx.data.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (campaign, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                value: campaign.campaignCode
              }, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (
              _ctx.setCampaignSelected(campaign.campaignCode, campaign.nameCampaign)
            ),
                  class: "d-flex justify-space-between align-center pa-2"
                }, [
                  _createElementVNode("p", null, _toDisplayString(campaign.nameCampaign), 1),
                  _createElementVNode("img", {
                    src: _ctx.getCampaignStatusIcon(campaign.isActive),
                    alt: campaign.isActive
                  }, null, 8, _hoisted_8)
                ], 8, _hoisted_7)
              ], 8, _hoisted_6))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
    ])
  ], 4))
}